/**
 * Helper to sync body class with side overlay state
 * Adds 'side-overlay-o' class to body when side overlay is open
 * Removes 'side-overlay-o' class from body when side overlay is closed
 *
 * This is abstracted to a helper so that if we ever update oneUI this should still work.
 */
let initialized = false;

const setupSideOverlayBodyLock = () => {
    if (initialized) {
        return;
    }

    const pageContainer = document.getElementById('page-container');
    if (!pageContainer) {
        return;
    }

    const syncBodyClass = () => {
        if (pageContainer.classList.contains('side-overlay-o')) {
            document.body.classList.add('side-overlay-o');
        } else {
            document.body.classList.remove('side-overlay-o');
        }
    };

    const observer = new MutationObserver(syncBodyClass);
    observer.observe(pageContainer, { attributes: true, attributeFilter: ['class'] });

    syncBodyClass();
    initialized = true;
};

export const initSideOverlayBodyLock = () => {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', setupSideOverlayBodyLock, { once: true });
        return;
    }

    setupSideOverlayBodyLock();
};
